import React, {Component} from 'react';

import AsyncTypeahead from './AsyncTypeahead.jsx';

import api from '../../../../api.js';

export default class UserTypehead extends Component {
  search = async (query) => {
    return (await api.users.getAll({
      'search[value]': query,
      'columns[email][searchable]': 1,
      'columns[fullname][searchable]': 1,
      'columns[freelance_id][searchable]': 1,
      'columns[id][searchable]': 1,
    })).data.data;
  }

  static defaultProps = {
    ...AsyncTypeahead.defaultProps,
    promptText: 'Entrez le nom, prénom ou email',
    formatObject: false,
  };

  render() {
    const { labelKey, valueField, formatObject, type, ...rest } = this.props;

    return (
      <AsyncTypeahead
        selected={this.props.input.value ? this.props.input.value : []}
        onSearch={this.search}
        labelKey={(option) => {
          return `${option?.fullname} (${option?.email}) [#${option?.id} ; #${option?.freelance_id}] `
        }}
        filterBy={(option, props) => {
          return !!option?.freelance_id;
        }}
        {...rest} />
    );
  }
}
